// extracted by mini-css-extract-plugin
module.exports = {"module":"page404_module__3hSpu"};